"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.MIN_WIDTH = exports.NAVIGATION_WIDTH = void 0;

var _react = _interopRequireDefault(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

var _styles = require("@material-ui/core/styles");

var _constants = require("../../utils/constants");

var NAVIGATION_WIDTH = 300;
exports.NAVIGATION_WIDTH = NAVIGATION_WIDTH;
var MIN_WIDTH = 600;
exports.MIN_WIDTH = MIN_WIDTH;

var Layout = function Layout(_ref) {
  var left = _ref.left,
      banner = _ref.banner,
      background = _ref.background,
      children = _ref.children,
      _ref$inboxZero = _ref.inboxZero,
      inboxZero = _ref$inboxZero === void 0 ? false : _ref$inboxZero;

  var _useTheme = (0, _styles.useTheme)(),
      palette = _useTheme.palette;

  return /*#__PURE__*/_react["default"].createElement("div", {
    className: "flex w-full h-full overflow-x-auto overflow-y-hidden bg-app"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: (0, _classnames["default"])('absolute inset-0 z-0', {
      hidden: !inboxZero
    })
  }, background), /*#__PURE__*/_react["default"].createElement("div", {
    className: (0, _classnames["default"])('relative z-30 flex-none sm:text-center md:text-right lg:text-left', {
      'dark:shadow-deep-r': !inboxZero
    }),
    style: {
      width: NAVIGATION_WIDTH,
      boxShadow: palette.type === _constants.themeMode.DARK || inboxZero ? undefined : '0 0px 30px rgba(0,0,0,.1), 0px 0px 30px rgba(0,0,0,0)'
    }
  }, left), /*#__PURE__*/_react["default"].createElement("div", {
    className: "w-full max-h-full flex flex-col relative z-10",
    style: {
      minWidth: MIN_WIDTH
    }
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "z-20"
  }, banner), children));
};

var _default = Layout;
exports["default"] = _default;
//# sourceMappingURL=index.js.map